<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <layouts></layouts>
        <sidebar-menu></sidebar-menu>
        <div class="page-wrapper">
            <div class="content">
                <pageheader :title="title" :title1="title1" />
                <!-- /product list -->
                <div class="activity">
                    <div class="activity-box">
                        <ul class="activity-list">
                            <li v-for="(item, index) in data" :key="index">
                                <div class="row mb-2">
                                    <div class="col">
                                        <span class="fw-bold">{{ item.nama }}</span><br>
                                        <span>{{ item.pesan }}</span><br>
                                    </div>
                                    <div class="col">
                                        <span class="d-block text-end">{{ item.dob }}</span>
                                    </div>
                                </div>
                                
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- /product list -->
            </div>
        </div>
    </div>
</template>
<script>

import Cookies from "js-cookie";
import axios from "axios";
import { ShowLoading, CloseLoading, ErrorConnectionTimeOut, base_url, AlertPopup } from "@/assets/js/function";

export default {
    data() {
        return {
            data: [],
            title: "Birthday",
            title1: "View all employees birthday on this month",
            api: "",
            config: "",
        };
    },
    name: "activities",

    created() {
        const token = Cookies.get("token_refresh");
        this.config = {
            headers: { Authorization: `Bearer ` + token },
            timeout: 30000,
        }
        let selectedBranch = Cookies.get("selectedBranch");
        if (selectedBranch !== null && selectedBranch !== undefined && selectedBranch !== '') {
            this.filter = selectedBranch;
        } else {
            this.filter = 0;
        }
        this.index();
    }
    ,
    methods: {
        index() {
            ShowLoading();
            let formData = new FormData();
            const newDate = new Date();
            const year = newDate.getFullYear();
            const month = String(newDate.getMonth() + 1).padStart(2, '0');
            const formattedDate = `${year}-${month}`;
            formData.append("periode", formattedDate);

            if (!this.filter) {
                const savedBranch = localStorage.getItem("selectedBranch");
                this.filter = savedBranch !== null ? savedBranch : 0;
            }
            formData.append("filter", this.filter == 0 ? '' : this.filter);

            for (let [key, value] of formData.entries()) {
              console.log(`${key}: ${value}`);
            }
            // return
            
            if (process.env.NODE_ENV === "development") {
                this.api = base_url + 'dashboard_bday';
            } else {
                this.api = base_url + 'dashboard_bday';
            }

            axios
                .post(this.api, formData, this.config)
                .then((response) => {
                    console.log(response.data);
                    if (response.data.status == true) {
                        this.data = response.data.data;
                        CloseLoading();
                    }


                    if (response.data.status == false) {
                        AlertPopup("error", "", response.data.message, null, false);
                    }
                })
                .catch((error) => {

                    ErrorConnectionTimeOut(error);
                });

        },
    }
};
</script>
  